var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('loader', {
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "isLoading": _vm.cdLoader
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.$t('crossDockPacking.crossDockPacking')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "cdField",
      "disabled": _vm.cdFieldsDisabled,
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder')
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.validateProductCrossDock($event)
      }
    },
    model: {
      value: (_vm.cdEanCode),
      callback: function($$v) {
        _vm.cdEanCode = $$v
      },
      expression: "cdEanCode"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.cdFieldsDisabled
    },
    on: {
      "click": _vm.validateProductCrossDock
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v("\n        " + _vm._s(_vm.$t('boxList.scan')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.onCrossDockReset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n        " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', [(_vm.cdDetails) ? _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderDetails')))])]), _vm._v("    \n      "), (_vm.cdQcDone) ? _c('span', {
    staticClass: "badge badge-pill badge-success",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.qcDone')))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.orderType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipByDate')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center"
  }, [_c('td', [_vm._v(_vm._s(_vm.cdValidateProductResult.orderId))]), _vm._v(" "), _c('td', [_vm._v("B2C Order")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.cdValidateProductResult.orderShiByDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cdValidateProductResult.totalQty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cdValidateProductResult.salesChannel))])])])])]) : _vm._e(), _vm._v(" "), _c('b-card-group', {
    staticClass: "form-group row",
    attrs: {
      "deck": ""
    }
  }, [(_vm.cdOutQcDetails) ? _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.outQCDetails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md "
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "height": "240px",
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": "1"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('returnReceiptReport.image')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.productDetails')) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "rowspan": "5"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin": "auto",
      "height": "150px",
      "width": "auto"
    },
    attrs: {
      "src": _vm.cdResponseProductDetails.productimage
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.ean')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.cdEanCode) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.name')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.cdResponseProductDetails.productname) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.color')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.cdResponseProductDetails.color) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.size')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.cdResponseProductDetails.size) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.mrp')) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.cdResponseProductDetails.mrp) + " ₹ ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "5%",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "50%"
    },
    attrs: {
      "type": "accept"
    },
    on: {
      "click": function($event) {
        _vm.crossDockQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.accept')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "50%"
    },
    attrs: {
      "disabled": "",
      "type": "reject"
    },
    on: {
      "click": function($event) {
        _vm.crossDockQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.reject')))])])])]) : _vm._e(), _vm._v(" "), (_vm.cdPackingDetails && _vm.issuggestionEnabled) ? _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.packingDetails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('crossDockPacking.recommendedPackingBoxType')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "badge badge-light",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.cdPackingDetRecommBoxType.name) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('crossDockPacking.confirmPackingBoxType')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cdPackingDetSelectedBoxType),
      expression: "cdPackingDetSelectedBoxType"
    }],
    staticClass: "form-control",
    style: ({
      'background-image': _vm.cdPackingDetSelectedBoxType.boxname == _vm.cdPackingDetRecommBoxType.name ? 'linear-gradient(to left, rgba(64, 255, 0, 0.3), rgba(255, 0, 0, 0) )' : ''
    }),
    attrs: {
      "name": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cdPackingDetSelectedBoxType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.crossDockBoxSelected]
    }
  }, [(false) ? _c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.cdPackingDetRecommBoxType.name))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cdPackingDetConfirmBoxType), function(boxTypeObj) {
    return _c('option', {
      style: ({
        'backgroundColor': boxTypeObj.boxname == _vm.cdPackingDetRecommBoxType.name ? '#e6ffd9' : 'white'
      }),
      domProps: {
        "value": boxTypeObj
      }
    }, [_vm._v("\n                " + _vm._s(boxTypeObj.boxname))])
  })], 2)])], 1)]), _vm._v(" "), (_vm.cdShowDiffPackBoxReason) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('crossDockPacking.differentPackingBoxReason')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [(!_vm.cdShowOtherReasonField) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cdPackingDetReason),
      expression: "cdPackingDetReason"
    }],
    staticClass: "form-control col-md",
    attrs: {
      "name": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cdPackingDetReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.crossDockBoxChangeReason]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.selectOverideReason')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Box not suitable'
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxNotSuitable')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Other'
    }
  }, [_vm._v(_vm._s(_vm.$t('common.other')))])]) : _vm._e(), _vm._v(" "), (_vm.cdShowOtherReasonField) ? _c('b-form-input', {
    ref: "otherReasonInput",
    staticClass: "col-md",
    style: ({
      'background-image': _vm.cdPackingDetReason ? '' : 'linear-gradient(to left, rgba(255, 0, 0, 0.3), rgba(255, 0, 0, 0) )'
    }),
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('crossDockPacking.enterOtherReason'),
      "value": ""
    },
    on: {
      "change": _vm.crossDockBoxChangeReason
    },
    model: {
      value: (_vm.cdPackingDetReason),
      callback: function($$v) {
        _vm.cdPackingDetReason = $$v
      },
      expression: "cdPackingDetReason"
    }
  }) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.boxWeight')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('b-form-input', {
    attrs: {
      "id": "cdboxweight",
      "type": "number",
      "placeholder": _vm.$t('boxList.weight')
    },
    model: {
      value: (_vm.cdPackingDetBoxWeight),
      callback: function($$v) {
        _vm.cdPackingDetBoxWeight = $$v
      },
      expression: "cdPackingDetBoxWeight"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.captureCrossDockBoxWeight
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('crossDockPacking.captureWeight')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin": "auto",
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.crossDockSaveBoxSugestion
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.saveBtn')))])])]) : _vm._e()], 1), _vm._v(" "), (_vm.cdShippingDetails) ? _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shippingDetails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('b-input-group', [(!_vm.cdshowOtherCourierNameField) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cdCourierName),
      expression: "cdCourierName"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cdCourierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.crossDockOtherCourierCompany]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.courierPlaceholder')))]), _vm._v(" "), _vm._l((_vm.cdValidateProductResult.salesChannelList), function(courierObj) {
    return _c('option', {
      domProps: {
        "value": courierObj.courierid
      }
    }, [_vm._v("\n              " + _vm._s(courierObj.couriername))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.cdshowOtherCourierNameField) ? _c('b-form-input', {
    ref: "otherCourierCompanyInput",
    staticClass: "col-md",
    style: ({
      'background-image': _vm.cdCourierName ? '' : 'linear-gradient(to left, rgba(255, 0, 0, 0.2), rgba(255, 0, 0, 0) )'
    }),
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.enterCourierCompany'),
      "value": ""
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.cdCourierName),
      callback: function($$v) {
        _vm.cdCourierName = $$v
      },
      expression: "cdCourierName"
    }
  }) : _vm._e(), _vm._v("  \n                "), (_vm.cdshowOtherCourierNameField) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.cdshowOtherCourierNameField = false;
        _vm.cdCourierName = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.cdCourierName == '') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.couriercompanyerr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "cdawbfield",
      "type": "text",
      "placeholder": _vm.$t('common.aWBNumberPlaceHolder')
    },
    model: {
      value: (_vm.cdAwbNo),
      callback: function($$v) {
        _vm.cdAwbNo = $$v
      },
      expression: "cdAwbNo"
    }
  }), _vm._v(" "), (_vm.cdAwbNo == '') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.awbNoerr))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.cdValidateProductResult.labelUrl || _vm.cdValidateProductResult.invoiceUrl) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row col-md"
  }, [(_vm.cdValidateProductResult.labelUrl) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-right": "2%",
      "background-color": "rgb(117 175 66)",
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.windowOpen(_vm.cdValidateProductResult.labelUrl)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.printLabel')))]) : _vm._e(), _vm._v(" "), (_vm.cdValidateProductResult.invoiceUrl) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-right": "2%",
      "background-color": "#44b8bd"
    },
    on: {
      "click": _vm.printCrossDockInvoice
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("\n            " + _vm._s(_vm.$t('common.printInvoice')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md",
    staticStyle: {
      "text-align": "right",
      "width": "100%",
      "margin-top": "3%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.completeCrossDockPacking
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n             " + _vm._s(_vm.$t('common.packingCompleted')))])])])]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30ae55a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ae55a3","hasScoped":true}!./src/views/components/packingb2c/packingCrossDock.component.html
// module id = 1968
// module chunks = 0